import { useQuery, useMutation, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { getProducts, getBestSellers, getProductDetails, getWishlist, searchProducts, updateWishlist, getBrands, getTransparencies, getMaterials } from "../../api/product.api";

export const useProducts = (params) => {
    return useQuery({
        queryKey: ["products", params],
        queryFn: () => getProducts(params),
        placeholderData: keepPreviousData,
        staleTime: 0,
    });
};

export const useBestSellers = (params = {}) => {
    return useQuery({
        queryKey: ["bestSellers", params],
        queryFn: () => getBestSellers(params || {}),
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};

export const useProductDetails = (params) => {
    return useQuery({
        queryKey: ["productDetails", params],
        queryFn: () => getProductDetails(params),
        enabled: !!params?.prd_code,
        staleTime: 1000 * 60 * 10, // 10 minutes
    });
};

export const useWishlist = (options = {}) => {
    return useQuery({
        queryKey: ["wishlist"],
        queryFn: getWishlist,
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...options
    });
};

export const useUpdateWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateWishlist,
        onSuccess: () => {
            // Invalidate wishlist to refetch
            queryClient.invalidateQueries({ queryKey: ["wishlist"] });
            // Optionally invalidate products if they contain "is_favorite" info
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["productDetails"] });
            queryClient.invalidateQueries({ queryKey: ["search"] });
            queryClient.invalidateQueries({ queryKey: ["bestSellers"] });
        },
    });
};

export const useSearch = (searchText) => {
    return useQuery({
        queryKey: ["search", searchText],
        queryFn: () => searchProducts(searchText),
        enabled: !!searchText,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};

export const useBrands = () => {
    return useQuery({
        queryKey: ["brands"],
        queryFn: getBrands,
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};

export const useTransparencies = () => {
    return useQuery({
        queryKey: ["transparencies"],
        queryFn: getTransparencies,
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};

export const useMaterials = () => {
    return useQuery({
        queryKey: ["materials"],
        queryFn: getMaterials,
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};


